import React from 'react';

function Icon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="234" height="333" version="1.1">
            <g transform="translate(0 -719.362)">
                <g>
                    <rect
                        width="233.244"
                        height="332.244"
                        x="0.378"
                        y="719.74"
                        fill="#fff"
                        fillOpacity="1"
                        stroke="gray"
                        strokeDasharray="none"
                        strokeLinecap="butt"
                        strokeLinejoin="miter"
                        strokeMiterlimit="4"
                        strokeOpacity="1"
                        strokeWidth="0.756"
                        rx="8.919"
                        ry="8.946"
                    ></rect>
                    <path
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        d="M12.899 780.702c0-.556-.031-.958-.031-1.514h3.545v-2.737c-2.244.072-4.673.24-6.774-.687-1.627-.893-2.076-2.97-1.748-4.68.281-1.927 1.353-3.638 2.75-4.957 1.82-1.946 4.14-3.26 6.562-4.316 2.472 1.075 4.843 2.431 6.685 4.428 1.66 1.56 2.765 3.764 2.731 6.071.036 1.665-.995 3.425-2.697 3.789-1.904.527-3.83.434-5.785.352v2.737h3.353c0 .556.03.958.03 1.514a665.864 665.864 0 00-8.621 0z"
                    ></path>
                    <path
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        d="M212.488 991.022c0 .556-.031.958-.031 1.514h3.545v2.737c-2.244-.072-4.673-.239-6.774.687-1.627.893-2.076 2.971-1.748 4.68.28 1.927 1.352 3.639 2.75 4.957 1.82 1.946 4.14 3.26 6.562 4.316 2.472-1.075 4.843-2.431 6.685-4.428 1.66-1.56 2.765-3.763 2.731-6.07.036-1.666-.996-3.426-2.697-3.79-1.904-.527-3.83-.433-5.785-.352v-2.737h3.353c0-.556.03-.958.03-1.514-2.632.019-5.778.019-8.621 0z"
                    ></path>
                    <path
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        d="M45.71 814.076c0-1.668-.093-2.873-.093-4.541h10.634v-8.211c-6.732.216-14.017.716-20.321-2.061-4.88-2.679-6.227-8.913-5.243-14.038.842-5.783 4.057-10.918 8.25-14.873 5.458-5.838 12.418-9.778 19.684-12.949 7.417 3.224 14.53 7.294 20.057 13.285 4.978 4.678 8.295 11.29 8.193 18.212.108 4.996-2.987 10.276-8.093 11.367-5.71 1.581-11.49 1.3-17.354 1.057v8.21h10.058c0 1.67.093 2.874.093 4.542-7.897-.055-17.336-.055-25.866 0z"
                    ></path>
                    <path
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        d="M162.45 814.076c0-1.668-.092-2.873-.092-4.541h10.634v-8.211c-6.732.216-14.018.716-20.322-2.061-4.88-2.679-6.226-8.913-5.242-14.038.842-5.783 4.056-10.918 8.25-14.873 5.458-5.838 12.417-9.778 19.684-12.949 7.417 3.224 14.53 7.294 20.057 13.285 4.978 4.678 8.294 11.29 8.192 18.212.108 4.996-2.987 10.276-8.092 11.367-5.711 1.581-11.491 1.3-17.354 1.057v8.21h10.058c0 1.67.092 2.874.092 4.542-7.896-.055-17.336-.055-25.865 0z"
                    ></path>
                    <path
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        d="M104.08 914.199c0-1.669-.093-2.873-.093-4.542h10.635v-8.211c-6.732.217-14.018.717-20.322-2.061-4.88-2.678-6.227-8.913-5.243-14.038.842-5.783 4.057-10.918 8.25-14.873 5.458-5.837 12.418-9.778 19.684-12.948 7.417 3.224 14.53 7.293 20.057 13.285 4.978 4.677 8.295 11.289 8.193 18.211.108 4.997-2.987 10.277-8.092 11.367-5.711 1.582-11.492 1.301-17.354 1.057v8.211h10.058c0 1.669.092 2.873.092 4.542-7.897-.056-17.336-.056-25.865 0z"
                    ></path>
                    <path
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        d="M45.71 957.648c0 1.668-.093 2.873-.093 4.541h10.634v8.212c-6.732-.217-14.017-.717-20.321 2.06-4.88 2.679-6.227 8.913-5.243 14.039.842 5.782 4.057 10.918 8.25 14.873 5.458 5.837 12.418 9.778 19.684 12.948 7.417-3.224 14.53-7.294 20.057-13.285 4.978-4.678 8.295-11.29 8.193-18.212.108-4.996-2.987-10.276-8.093-11.366-5.71-1.582-11.49-1.301-17.354-1.057v-8.212h10.058c0-1.668.093-2.873.093-4.54-7.897.055-17.336.055-25.866 0z"
                    ></path>
                    <path
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        d="M162.45 957.648c0 1.668-.092 2.873-.092 4.541h10.634v8.212c-6.732-.217-14.018-.717-20.322 2.06-4.88 2.679-6.226 8.913-5.242 14.039.842 5.782 4.056 10.918 8.25 14.873 5.458 5.837 12.417 9.778 19.684 12.948 7.417-3.224 14.53-7.294 20.057-13.285 4.978-4.678 8.294-11.29 8.192-18.212.108-4.996-2.987-10.276-8.092-11.366-5.711-1.582-11.491-1.301-17.354-1.057v-8.212h10.058c0-1.668.092-2.873.092-4.54-7.896.055-17.336.055-25.865 0z"
                    ></path>
                    <g
                        style={{ lineHeight: '0%' }}
                        fill="#000"
                        fillOpacity="1"
                        stroke="none"
                        strokeWidth="1"
                        fontFamily="Levenim MT"
                        fontSize="3.772"
                        fontStretch="normal"
                        fontStyle="normal"
                        fontVariant="normal"
                        fontWeight="bold"
                        letterSpacing="0"
                        transform="scale(.9951 1.00492)"
                        wordSpacing="0"
                    >
                        <path
                            style={{ lineHeight: '1.25' }}
                            strokeWidth="1"
                            d="M26.751 742.302q0 4.365-2.65 6.937-2.63 2.572-6.996 2.572-4.19 0-6.625-2.046-2.65-2.182-2.65-6.294 0-.663 1.052-.663h2.552q.41 0 .76.117.117.195.156.507.332 2.202 1.267 3.157 1.052 1.072 3.235 1.072 2.182 0 3.527-1.54 1.267-1.461 1.267-3.663 0-5.437-4.502-5.437-1.637 0-3.293 1.13h-3.216q-.448 0-.857-.117-.195-.195-.195-.448 0-2.767.293-6.976l.506-6.996h14.615q.507 0 .916.156.176.39.176 2.728 0 .39-.04.643-.136.624-1.13.624H14.338q.058 1.052-.175 3.215-.234 2.143-.176 3.196 2.007-1.247 4.19-1.247 4.014 0 6.353 2.728 2.221 2.572 2.221 6.645z"
                            fontSize="39.909"
                        ></path>
                    </g>
                    <g
                        style={{ lineHeight: '0%' }}
                        fill="#000"
                        fillOpacity="1"
                        stroke="none"
                        strokeWidth="1"
                        fontFamily="Levenim MT"
                        fontSize="3.772"
                        fontStretch="normal"
                        fontStyle="normal"
                        fontVariant="normal"
                        fontWeight="bold"
                        letterSpacing="0"
                        transform="scale(-.9951 -1.00492)"
                        wordSpacing="0"
                    >
                        <path
                            style={{ lineHeight: '1.25' }}
                            strokeWidth="1"
                            d="M-208.401-1020.74q0 4.365-2.65 6.938-2.631 2.572-6.996 2.572-4.19 0-6.626-2.046-2.65-2.183-2.65-6.295 0-.662 1.052-.662h2.553q.41 0 .76.117.117.195.156.507.331 2.202 1.267 3.156 1.052 1.072 3.234 1.072 2.183 0 3.528-1.54 1.266-1.46 1.266-3.663 0-5.437-4.501-5.437-1.637 0-3.294 1.13h-3.215q-.448 0-.857-.116-.195-.195-.195-.449 0-2.767.292-6.976.253-3.508.507-6.996h14.615q.507 0 .916.156.175.39.175 2.728 0 .39-.039.643-.136.624-1.13.624h-10.581q.058 1.052-.176 3.215-.234 2.144-.175 3.196 2.007-1.247 4.19-1.247 4.014 0 6.352 2.728 2.222 2.572 2.222 6.645z"
                            fontSize="39.909"
                        ></path>
                    </g>
                </g>
            </g>
        </svg>
    );
}

export default Icon;
